import React, { useEffect, useRef, useState } from "react";

const ModalContent = ({ isOpen, onClose, setWidth = '400px', maxWidth, setHeight = 'auto', position = 'center', title = 'Cari Data', children, backgroundImage, isWarning = true, showCloseButton = true }) => {
    const [show, setShow] = useState(false);
    const [isRender, setIsRender] = useState(isOpen);
    const closeTimerRef = useRef(null);

    useEffect(() => {
        if (closeTimerRef.current) {
            clearTimeout(closeTimerRef.current);
            closeTimerRef.current = null;
        }

        if (isOpen) {
            setIsRender(true);
            setShow(false);
            requestAnimationFrame(() => {
                requestAnimationFrame(() => {
                    setShow(true);
                });
            });
        } else {
            setShow(false);
            closeTimerRef.current = setTimeout(() => {
                setIsRender(false);
            }, 300);
        }

        return () => {
            if (closeTimerRef.current) {
                clearTimeout(closeTimerRef.current);
                closeTimerRef.current = null;
            }
        };
    }, [isOpen]);

    if (!isRender) return null;

    return (
        <div className={`modal-overlay fixed inset-0 bg-black/20 z-[1050] transition-opacity duration-300 flex ${position === 'right' ? 'justify-end' : position === 'left' ? 'justify-start' : 'justify-center'} items-center ${show ? 'opacity-100' : 'opacity-0'}`}>
            <div className={`modal-content mx-4 transition-all duration-300 transform ${show ? 'translate-y-0 opacity-100' : 'translate-y-4 opacity-0'}`} style={{ width: setWidth, height: setHeight, maxWidth:maxWidth }}>
                <div className="relative bg-white rounded-2xl shadow-sm" style={{backgroundImage: backgroundImage || 'linear-gradient(180deg, #ea2427a6 0%, #F1F5F9 35%)', boxShadow: '1px 7px 17px rgba(0 118 255 / 7%)'}}>
                    <div className="flex md:hidden flex-row items-start justify-between">
                        <div>
                            {isWarning && <img className="w-[100px] rounded-ss-[20px]" src={"/asset/warning.png"} />}
                        </div>
                        {showCloseButton && (
                            <div className="flex flex-row items-center gap-1 cursor-pointer p-0" onClick={onClose}>
                                <img src={"/asset/icon/close.svg"} />
                            </div>
                        )}
                    </div>
                    <div className="">
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ModalContent;